import { Fields } from "../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./SchemaFactory";
import { UserRegisterDTO } from "../domain/models/dto/UserRegisterDTO";
import * as Yup from "yup";

export const userRegisterFields: Fields<UserRegisterDTO> = {
    firstName: {
        min: 2,
        max: 50,
        placeholderKey: `auth.fields.firstName`,
        type: "text",
        initial: "",
    },
    lastName: {
        min: 2,
        max: 50,
        placeholderKey: `auth.fields.lastName`,
        type: "text",
        initial: "",
    },
    middleName: {
        min: 2,
        max: 50,
        placeholderKey: `auth.fields.middleName`,
        type: "text",
        optional: true,
        initial: "",
    },
    email: {
        min: 1,
        max: 128,
        placeholderKey: `auth.fields.email`,
        type: "email",
        initial: "",
        patternErrorKey: "errors.validation.invalidOption",
    },
    phone: {
        min: 13,
        max: 20,
        placeholderKey: `auth.fields.phone`,
        type: "text",
        initial: "",
        optional: true,
        // pattern: /^\+38[\d\s\(\)-]+$/, // Ukrainian phone number format
        patternErrorKey: "errors.validation.invalidPhone",
    },
    password: {
        min: 8,
        max: 128,
        placeholderKey: `auth.fields.password`,
        type: "password",
        initial: "",
    },
    confirmPassword: {
        min: 8,
        max: 128,
        placeholderKey: `auth.fields.password`,
        type: "password",
        initial: "",
    },
};

export const UserRegisterSchemaFactory = (t: TFunction) => {
    const baseSchema = schemaFactory(t, userRegisterFields);
    return baseSchema.shape({
        confirmPassword: (
            baseSchema.fields.confirmPassword as Yup.StringSchema
        ).concat(
            Yup.string()
                .required(t("errors.validation.required"))
                .oneOf(
                    [Yup.ref("password"), null],
                    t("errors.validation.password.passwordsMustMatch")
                )
        ),
    });
};
